import { Reducer } from 'redux';
import { ISettingsApplicationStateStore } from './type';
import { TypesSettingsApplication } from 'redux/actions/settingsApplication/type';
import { getStorageLoanPurpose, getStoragePromoCodeApplication } from 'utils';

const settingsApplicationState: ISettingsApplicationStateStore = {
  amount: 0,
  term: 0,
  promo_code: getStoragePromoCodeApplication(),
  loan_purpose: +getStorageLoanPurpose(),
};

export const settingsApplication: Reducer<ISettingsApplicationStateStore> = (
  state = settingsApplicationState,
  action
) => {
  switch (action.type) {
    case TypesSettingsApplication.SET_SETTINGS_APPLICATION_AMOUNT:
      return {
        ...state,
        amount: action.data,
      };
    case TypesSettingsApplication.SET_SETTINGS_APPLICATION_TERM:
      return {
        ...state,
        term: action.data,
      };

    case TypesSettingsApplication.SET_SETTINGS_APPLICATION_PROMOCODE:
      return {
        ...state,
        promo_code: action.data,
      };

    case TypesSettingsApplication.SET_SETTINGS_APPLICATION_LOAN_PURPOSE: {
      return {
        ...state,
        loan_purpose: action.data,
      };
    }

    default:
      return state;
  }
};
